import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TimeZone } from 'app/modules/main/models/time-zone';
import { DomainEndpointsService } from 'app/modules/main/services/domain-endpoints.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AdvertiserTimeZoneService {

  constructor(
    private readonly http: HttpClient,
    private readonly serviceEndpoints: DomainEndpointsService,
  ) {
  }

  public fetch(
    advertiserId: number
  ): Observable<TimeZone> {

    return this.performRequest(advertiserId);
  }

  private performRequest(
    advertiserId: number
  ): Observable<TimeZone> {

    const url = this.serviceEndpoints.advertiserTimeZoneUrl
      .replace(':advertiserId', String(advertiserId));

    return this.http.get<TimeZone>(url);
  }

}
